import { css } from 'emotion';

import { breakpoints } from '../styles';

export const logo = css`
  height: 30px;
  cursor: pointer;
  margin-right: 43.2px;
  margin-left: 20px;
`;

export const logoWithoutText = css`
  ${logo};
  width: 27px;
  min-width: 27px;
  display: none;

  @media screen and (max-width: ${breakpoints.tablet}) {
    display: block;
  }
`;

export const logoWithText = css`
  ${logo};
  width: 62.8px;
  min-width: 62.8px;
  display: block;

  @media screen and (max-width: ${breakpoints.tablet}) {
    display: none;
  }
`;

export const itemsWrapper = css`
  display: flex;
  align-items: center;
`;

export const childrenWrapper = css`
  display: flex;
  width: 100%;
`;
